import React, { useState } from "react";
import Customization from "./Customization";

import {
  SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
  UPDATE_CART_FILTERED_MENU_ORDER,
} from "../../../../store/types";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";

const CustomisationEditModel = (props) => {
  const [custom, setCustom] = useState(false);
  const dispatch = useDispatch();

  const [repeatSizeModal, setRepeatSizeModal] = useState(false);
  const [showRepeatSize, setShowRepeatSize] = useState(false);

  const [state, setState] = useState({
    cart: 0,
  });
  const onClickContinue = (qty) => {
    const formData = {};
    formData.cartLength = qty;
    formData.id = props.customizationData._id;

    dispatch({
      type: UPDATE_CART_FILTERED_MENU_ORDER,
      payload: formData,
    });
    setState({ ...state, cart: qty });
  };
  const incrementHandler = () => {
    setState({ ...state, cart: state.cart + 1 });

    const formData = {};
    formData.cartLength = props.customizationData.cartLength + 1;
    formData.id = props.customizationData._id;

    dispatch({
      type: UPDATE_CART_FILTERED_MENU_ORDER,
      payload: formData,
    });

    if (props.customizationData.cartLength + 1 > 1) {
      let cartData = JSON.parse(JSON.stringify(props.cart_data));

      let getIndex = 0;
      for (let i = 0; i < props.cart_data.length; i++) {
        //      props.cart_data[i][0].size._id
        for (let j = 0; j < props.customizationData.size.length; j++) {
          if (
            props.cart_data[i][0].size._id ===
            props.customizationData.size[j]._id
          ) {
            getIndex = i;
            break;
          }
        }
      }
      cartData[getIndex][0].quantity = cartData[getIndex][0].quantity + 1;
      dispatch({
        type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
        payload: cartData,
      });
    }
  };

  return (
    <React.Fragment>
      <Customization
        open={custom}
        setOpen={setCustom}
        onClickContinue={(qty) => onClickContinue(qty)}
        incrementHandler={(e) => incrementHandler(e)}
        customizationData={props.customizationData}
        orderSelected={props.orderSelected}
        categoryName={props.categoryName}
        edit={props.edit}
        item={props.item}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  cart_data: state.vendorOrdering.vendor_cart_data,
});

export default connect(mapStateToProps, null)(CustomisationEditModel);
